// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cameras_tab-button__aYJGt {
    background-color: #FFFFFF;
    color: #5D8EA4;
    width: 126px;
    height: 34px;
    font-size: 14px;
    border-radius: 5px;
    border: none;
    margin-right: 5px;
}

.cameras_tab-button-active__eI735 {
    background-color: #0095FF;
    color: #FFFFFF;
}

.cameras_tab-content-container__qv8Qb {
    margin-top: 20px;
    width: 100%;
    word-wrap: break-word;
}

.cameras_form-textfield__ejTcr {
    margin-bottom: 10px
}

.cameras_camera-content__YxYfy {
    padding: 30px;
    background-color: var(--color-content);
    color: var(--color-main-typography);

    width: 100%;
    height: 100vh;
}

.cameras_camera-tabs-background__Ry-ML {
    width: 100%;
    height: 100%;
    background-color: var(--color-content-sidebar);
    padding: 5px;
    border-radius: 5px;
}

.cameras_search-controls-container__cAqn8 {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 20px;
    padding: 0;
}

.cameras_search-field-container__tPHZv {
    display: flex;
    flex: 16 1;
}

.cameras_search-filter-container__tttkr {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 3 1;
}

.cameras_mainWrapper__-8Ixq {
    flex: 1 1;
    min-height: 100%;
    display: flex;
    align-items: flex-start;
}

.cameras_rightBlock__KWzrq {
    flex: 1 1;
    background: var(--color-content);
    padding: 30px;
}

.cameras_content-heading-container__LMQnF {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;
}

.cameras_content-heading__h3Uw7 {
    margin-bottom: 40px;
    font-weight: 700;
    font-size: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.cameras_content-sidebar-control__iLA5K {
    display: none;
}

.cameras_content-container__9SrjH {
    padding: 0;
}

@media screen and (max-width: 1000px) {
    .cameras_mainWrapper__-8Ixq {
        width: 100%;
    }

    .cameras_rightBlock__KWzrq {
        background: var(--color-content);
        height: 100vh;
        padding: 30px;
        width: 100%;
        padding: 0;
    }
    .cameras_content-container__9SrjH {
        padding: 30px;
    }

    .cameras_content-heading-container__LMQnF {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }

    .cameras_content-heading__h3Uw7 {
        margin-bottom: 40px;
        font-weight: 700;
        font-size: 20px;
    }

    .cameras_content-sidebar-control__iLA5K {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .cameras_tab-content-container-image__7E1cZ {
        width: 100%
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/cameras/cameras.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,mCAAmC;;IAEnC,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,8CAA8C;IAC9C,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,UAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAO;AACX;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,SAAO;IACP,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,gCAAgC;QAChC,aAAa;QACb,aAAa;QACb,WAAW;QACX,UAAU;IACd;IACA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,8BAA8B;IAClC;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI;IACJ;AACJ","sourcesContent":[".tab-button {\n    background-color: #FFFFFF;\n    color: #5D8EA4;\n    width: 126px;\n    height: 34px;\n    font-size: 14px;\n    border-radius: 5px;\n    border: none;\n    margin-right: 5px;\n}\n\n.tab-button-active {\n    background-color: #0095FF;\n    color: #FFFFFF;\n}\n\n.tab-content-container {\n    margin-top: 20px;\n    width: 100%;\n    word-wrap: break-word;\n}\n\n.form-textfield {\n    margin-bottom: 10px\n}\n\n.camera-content {\n    padding: 30px;\n    background-color: var(--color-content);\n    color: var(--color-main-typography);\n\n    width: 100%;\n    height: 100vh;\n}\n\n.camera-tabs-background {\n    width: 100%;\n    height: 100%;\n    background-color: var(--color-content-sidebar);\n    padding: 5px;\n    border-radius: 5px;\n}\n\n.search-controls-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    margin-bottom: 20px;\n    padding: 0;\n}\n\n.search-field-container {\n    display: flex;\n    flex: 16;\n}\n\n.search-filter-container {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    flex: 3;\n}\n\n.mainWrapper {\n    flex: 1;\n    min-height: 100%;\n    display: flex;\n    align-items: flex-start;\n}\n\n.rightBlock {\n    flex: 1;\n    background: var(--color-content);\n    padding: 30px;\n}\n\n.content-heading-container {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 40px;\n}\n\n.content-heading {\n    margin-bottom: 40px;\n    font-weight: 700;\n    font-size: 20px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.content-sidebar-control {\n    display: none;\n}\n\n.content-container {\n    padding: 0;\n}\n\n@media screen and (max-width: 1000px) {\n    .mainWrapper {\n        width: 100%;\n    }\n\n    .rightBlock {\n        background: var(--color-content);\n        height: 100vh;\n        padding: 30px;\n        width: 100%;\n        padding: 0;\n    }\n    .content-container {\n        padding: 30px;\n    }\n\n    .content-heading-container {\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    .content-heading {\n        margin-bottom: 40px;\n        font-weight: 700;\n        font-size: 20px;\n    }\n\n    .content-sidebar-control {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .tab-content-container-image {\n        width: 100%\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tab-button": `cameras_tab-button__aYJGt`,
	"tab-button-active": `cameras_tab-button-active__eI735`,
	"tab-content-container": `cameras_tab-content-container__qv8Qb`,
	"form-textfield": `cameras_form-textfield__ejTcr`,
	"camera-content": `cameras_camera-content__YxYfy`,
	"camera-tabs-background": `cameras_camera-tabs-background__Ry-ML`,
	"search-controls-container": `cameras_search-controls-container__cAqn8`,
	"search-field-container": `cameras_search-field-container__tPHZv`,
	"search-filter-container": `cameras_search-filter-container__tttkr`,
	"mainWrapper": `cameras_mainWrapper__-8Ixq`,
	"rightBlock": `cameras_rightBlock__KWzrq`,
	"content-heading-container": `cameras_content-heading-container__LMQnF`,
	"content-heading": `cameras_content-heading__h3Uw7`,
	"content-sidebar-control": `cameras_content-sidebar-control__iLA5K`,
	"content-container": `cameras_content-container__9SrjH`,
	"tab-content-container-image": `cameras_tab-content-container-image__7E1cZ`
};
export default ___CSS_LOADER_EXPORT___;
